import { useHistory, useLocation } from 'react-router-dom'
import { useMount } from 'react-use'
import { getModalUrl } from 'lib/modals'
import { getFullPath } from 'lib/location'
import { useEffect, useState } from 'react'

/**
 * Because of the state of ad creation flow in Nettiauto and other verticals,
 * we need to alert user if navigating back as otherwise ad will be lost.
 *
 * We will edit the history so that navigating back will display warning modal instead of navigating back to vertical.
 */
const useAdPostPreventBacKNav = (enabled) => {
    const history = useHistory()
    const location = useLocation()
    const [disableBeforeunload, setDisableBeforeUnload] = useState(false)

    useMount(() => {
        if (enabled) {
            history.replace(getModalUrl(history.location, 'ilmoituksen-jatto-varoitus-tietojen-menettamisesta'))

            if (location.hash === '#/modal/ilmoituksen-jatto-varoitus-tietojen-menettamisesta') {
                // we don't want to show the "prevent back nav warning" if user just entered the page,
                // so clear the modal hash path.
                history.push(getFullPath(location, { hash: false }))
            } else {
                history.push(getFullPath(location))
            }
        }
    })

    useEffect(() => {
        if (enabled && !disableBeforeunload) {
            const beforeunload = (e) => {
                e.preventDefault()

                // Leaving page, ad data will be lost
                // This message is not displayed at all in "modern" browsers
                // as the browser will display generic message instead.
                const message = 'Olet poistumassa sivulta, myynti-ilmoituksen tiedot menetetään'
                e.returnValue = message
                return message
            }

            window.addEventListener('beforeunload', beforeunload)

            return () => {
                window.removeEventListener('beforeunload', beforeunload)
            }
        }
    }, [enabled, disableBeforeunload])

    return { setDisableBeforeUnload }
}

export default useAdPostPreventBacKNav
